import React from 'react';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';

// Components
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';
import { useActiveTableCallback, useActiveTableSelector } from '../../../../../element/table/store/hotTableStoreHooks';
import createSwitchableTableComponent from './createSwitchableTableComponent';
import LegacyAddColumnTool from './legacy/LegacyAddColumnTool';

// Utils
import { getNewTransactionId } from '../../../../../utils/undoRedo/undoRedoTransactionManager';
import { isSelectingMultipleSelections } from '../../../../../element/table/utils/tableCellSelectionUtils';
import { addHotTableColsRight } from '../../../../../element/table/utils/hotInstanceUtils/hotTableGridOperationsUtils';

// Selectors
import { selectActiveTableCellSelection } from '../../../../../element/table/store/selectors/activeHotTableSelectors';

type AddColumnToolProps = Record<string, unknown> & {
    element?: ImMNElement;
};

const AddColumnTool: React.FC<AddColumnToolProps> = (props) => {
    const currentCellSelections = useActiveTableSelector(selectActiveTableCellSelection);

    const onClick = useActiveTableCallback(
        (activeTable) => addHotTableColsRight(activeTable.instance, undefined, getNewTransactionId()),
        [],
    );

    return (
        <div className="AddColumnTool">
            <ToolbarTool
                {...props}
                onClick={onClick}
                isActive={false}
                disabled={isSelectingMultipleSelections(currentCellSelections)}
                tooltipEnabled={true}
                shortcut={['alt', '→']}
            >
                <Icon name="toolbar-add-column" />
            </ToolbarTool>
        </div>
    );
};

export default createSwitchableTableComponent<AddColumnToolProps>(LegacyAddColumnTool, AddColumnTool);
